import { JSONContent } from '@tiptap/core';

import { ScreenReaderOnly } from 'approot/shared/styles/global.styles';
import {
  InteractiveAudioButtonContainer,
  InteractiveDisplayItem,
  InteractiveDragContainer,
  InteractiveItemImage,
  InteractiveTextImageContainer,
} from './interactive-drag.style';
import { ImageViewWrapper } from '../../image/image.style';
import { ComponentImageContainer } from '../../component-image.style';
import { InquisitiveActivitiesResponseVariant } from 'global/constants';
import {
  isTextImageVariant,
  isTextVariant,
} from '../../interactive-response/shared/interactive-response-shared.utils';
import InteractiveResponseRichtextView from '../../interactive-response/shared/interactive-response-richtext-view';
import InteractiveResponseAudioStatic from '../../interactive-response/shared/interactive-response-audio-static';

const InteractiveDragDisplay = ({
  imageUrl,
  description,
  isFit,
  baseColour,
  variant,
  text,
  richtext,
  audioUrl,
  scaleTo,
}: {
  description: string;
  imageUrl?: string | null;
  isFit?: boolean;
  baseColour: string | null;
  variant: InquisitiveActivitiesResponseVariant;
  text: string | null;
  richtext: JSONContent | null;
  audioUrl?: string | null;
  scaleTo?: number;
}) => {
  const imageContent = isTextVariant(variant) ? null : imageUrl && !isFit ? (
    <InteractiveItemImage imageUrl={imageUrl} imageHasLoaded />
  ) : imageUrl ? (
    <ImageViewWrapper>
      <ComponentImageContainer $imageHasLoaded>
        <img src={imageUrl} alt="" />
      </ComponentImageContainer>
    </ImageViewWrapper>
  ) : null;

  return (
    <>
      <InteractiveDragContainer $scaleTo={scaleTo}>
        <InteractiveDisplayItem
          $baseColour={!isTextVariant(variant) ? null : baseColour}
        >
          {isTextVariant(variant) ? (
            <InteractiveResponseRichtextView
              baseColour={baseColour}
              richtext={richtext}
            />
          ) : isTextImageVariant(variant) ? (
            <>
              {imageContent}
              {text && (
                <InteractiveTextImageContainer aria-hidden>
                  {text}
                </InteractiveTextImageContainer>
              )}
            </>
          ) : (
            imageContent
          )}
          {audioUrl && (
            <InteractiveAudioButtonContainer>
              <InteractiveResponseAudioStatic />
            </InteractiveAudioButtonContainer>
          )}
          <ScreenReaderOnly>{description}</ScreenReaderOnly>
        </InteractiveDisplayItem>
      </InteractiveDragContainer>
    </>
  );
};

export default InteractiveDragDisplay;
